import { render, staticRenderFns } from "./HeaderMockup.vue?vue&type=template&id=ed6de284&"
import script from "./HeaderMockup.vue?vue&type=script&lang=js&"
export * from "./HeaderMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports